import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#5ce1e6] text-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Contact Information
            </h3>
            <div className="space-y-3 text-slate-700">
              <a href="tel:0614481090" className="flex items-start gap-3 hover:text-slate-900 transition-colors">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>Telephone: 061 448 1090</span>
              </a>
              <a href="https://wa.me/27659972538?text=Hi%20Bong,%20I'd%20like%20to%20book%20a%20physiotherapy%20appointment." className="flex items-start gap-3 hover:text-slate-900 transition-colors" target="_blank" rel="noopener noreferrer">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>WhatsApp: 065 997 2538</span>
              </a>
              <a href="mailto:bnphysio0@gmail.com" className="flex items-start gap-3 hover:text-slate-900 transition-colors">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>bnphysio0@gmail.com</span>
              </a>
              <a 
                href="https://www.instagram.com/bn_physiotherapy?igsh=em1jM3o5bzBwZ3g=" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-start gap-3 hover:text-slate-900 transition-colors"
              >
                <Instagram className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>@bn_physiotherapy</span>
              </a>
            </div>
          </div>

          {/* Location */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Location
            </h3>
            <div className="space-y-3 text-slate-700">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p>KT Health & Wellness Medical Center</p>
                  <p>Upper level, Cedar Square, Fourways</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-slate-900">Home Visits</p>
                  <p>Johannesburg North and West Rand area</p>
                </div>
              </div>
            </div>
          </div>

          {/* Operating Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Operating Hours
            </h3>
            <div className="space-y-2 text-slate-700">
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <span>Monday - Friday: 09:00 - 18:00</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <span>Saturday: 09:00 - 13:00</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <span>Sunday: Closed</span>
              </div>
            </div>
            
            <div className="mt-6">
              <Link 
                to="/book" 
                className="inline-block px-6 py-2 bg-slate-900 text-white rounded-full font-medium hover:bg-slate-800 transition-colors"
                data-testid="footer-book-btn"
              >
                Book Appointment
              </Link>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-8 map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3584.2!2d28.0126!3d-26.0178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e957359bfc6b5f5%3A0x8b3c57c7c7c7c7c7!2sCedar%20Square%20Shopping%20Centre%2C%20Cnr%20Cedar%20Rd%20%26%20Witkoppen%20Rd%2C%20Fourways%2C%20Sandton%2C%202055!5e0!3m2!1sen!2sza!4v1700000000000!5m2!1sen!2sza"
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="BN Physiotherapy - Cedar Square, Fourways"
          />
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-[#22d3ee] text-center text-slate-700 text-sm">
          <p>&copy; {new Date().getFullYear()} BN Physiotherapy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
